export default __webpack_public_path__ + "static/media/hisham_ahmad.ce8ed0c7.jfif";